class ConstituencyModel{
    sno?: number;
    count?: number;
    constituencyId?:number;
    name?:string;
    districtId?:number;
    districtName?: string;

}
        export default ConstituencyModel;
    